import React, { useState } from "react";
import {
  InputContainer,
  RadioButtons,
  TextArea,
} from "components/common";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useCommsBatching } from "utils";
import { clearBatch } from "state/reducers/communicationBatching";
import MarketingButtons from "./utils/components/MarketingButtons";
import MarketingNavigation from "./utils/components/MarketingNavigation";
import MarketingStepper from "./utils/components/MarketingStepper";
import CSVUpload from "./utils/components/CSVUpload";

const MAIN_DB = "Main Db";
const REDSHIFT = "Redshift";
const DB_LIST = [MAIN_DB, REDSHIFT];

const ListRadioButtons = ({ element }) => (
  <div className="flex" key={element.id}>
    <p>{element.id}</p>
  </div>
);

const QueryDetails = () => {
  const [selectedDb, setSelectedDb] = useState(MAIN_DB);
  const [query, setQuery] = useState("");
  return (
    <>
      <div>
        <p className="font-semibold">2. Choose which database</p>
        <RadioButtons
          key="query"
          elements={DB_LIST.map((item) => ({
            id: item,
            selected: item === selectedDb,
          }))}
          component={ListRadioButtons}
          didSelect={(element) => {
            setSelectedDb(element.id);
          }}
          nameRadioButton
        />
      </div>
      <div>
        <p className="font-semibold">3. Type in your query</p>
        <InputContainer className="mt-2">
          <TextArea
            className="resize-none"
            placeholder="SELECT * FROM users"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </InputContainer>
      </div>
    </>

  );
};

const CSV = "CSV";
// const QUERY = "Query";
const listTypes = [CSV];

const BatchList = () => {
  const [bypassed, setBypassed] = useState(false);
  const [listType, setListType] = useState(CSV);
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    fileName,
    missingColumns,
    batchId,
  } = useSelector((state) => state.communicationBatching);

  const { getNextLink, getPreviousLink } = useCommsBatching({ currentPage: 'list' });

  if (!batchId) {
    dispatch(clearBatch());
    history.push('/v2-marketing');
  }

  const handleDiscardChanges = () => {
    dispatch(clearBatch());
    history.push("/v2-marketing");
  };

  return (
    <div className="flex flex-col h-full">
      <MarketingNavigation/>
      <MarketingStepper />
      <MarketingButtons
        discardButton="Discard"
        discardChanges={handleDiscardChanges}
        prevButton="Previous"
        prevLink={getPreviousLink()}
        nextButton="Continue"
        nextLink={getNextLink()}
        spaceBetween
        required={
          !fileName || (missingColumns.length && !bypassed)
        }
      />
      <div
        className='flex flex-col h-full'
      >
        <div>
          <div>
            <p className="font-semibold">1. Add your list below</p>
            <RadioButtons
              elements={listTypes.map((item) => ({
                id: item,
                selected: item === listType,
              }))}
              component={ListRadioButtons}
              didSelect={(element) => {
                setListType(element.id);
              }}
              nameRadioButton
            />
          </div>
          {
            listType === CSV ?
              <CSVUpload bypassed={bypassed} setBypassed={setBypassed}/>
              :
              <QueryDetails/>
          }
        </div>
      </div>
    </div>
  );
};

export default BatchList;
